import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';

class Option extends PureComponent {
  handleChange = event => {
    const { value } = event.currentTarget.dataset;
    const { onRequestSelect } = this.props;

    if (onRequestSelect) {
      onRequestSelect(value);
    }
  };

  render() {
    const { className, value, checked, children, ...props } = this.props;

    return (
      <Wrapper
        className={className}
        data-checked={checked}
        data-value={value}
        value={value}
        onClick={this.handleChange}
        {...props}
      >
        {children}
      </Wrapper>
    );
  }
}

Option.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onRequestSelect: PropTypes.func,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]),
  children: PropTypes.node,
};

Option.defaultProps = {
  className: null,
  children: null,
  as: null,
  value: null,
  onRequestSelect: null,
};

export default Option;
